<div class="content-container" #formContainer>
  <lib-card>
    <lib-card-body class="form-container">
      <form [formGroup]="form">
        <lib-form-control>
          <p class="title">{{ "nouns.diagnosis-description" | translate }}</p>
          <lib-textarea [maxlength]="200" formControlName="diagnosis_description"> </lib-textarea>
        </lib-form-control>

        <lib-form-control>
          <div class="procedures-select-container">
            <app-procedures-select
              [disabled]="isSubmitting"
              [reset$]="resetProceduresSelect$"
              [proceduresArray]="procedures"
              (onProtocolSelectionChanged)="handleProtocolSelection($event)"
            >
            </app-procedures-select>
          </div>
        </lib-form-control>

        <div class="section-container --gray">
          <ul>
            <li class="section-row">
              <p class="section-header">{{ "sessions-details.insert-CID" | translate }}</p>
            </li>

            <li class="section-row" *ngFor="let cid of medicalRecord.cid; let i = index; trackBy: trackByIndex">
              <app-spinner-form-control [isLoading]="isCidLoading[i]">
                <app-cid-select
                  [selectedCid]="cid"
                  [disabled]="isCidLoading[i]"
                  (setIsSearching)="setCidLoadingStatus(i, $event)"
                  (onCidSelected)="onSelectCid(i, $event)"
                >
                </app-cid-select>
              </app-spinner-form-control>

              <button
                *ngIf="medicalRecord.cid.length - 1 === i"
                type="button"
                class="row-btn --add"
                [disabled]="!cid.id"
                [class.disabled]="!cid.id"
                (click)="onClickAddCid()"
              >
                <span>+</span>
              </button>

              <button
                *ngIf="medicalRecord.cid.length - 1 !== i"
                type="button"
                class="row-btn --remove"
                (click)="onClickRemoveCid(i)"
              >
                <span>+</span>
              </button>
            </li>
          </ul>
        </div>

        <lib-form-control>
          <label class="title" for="note">{{ "nouns.note" | translate }}</label>
          <lib-textarea maxlength="200" formControlName="note"> </lib-textarea>
        </lib-form-control>
      </form>
    </lib-card-body>
  </lib-card>

  <footer class="footer">
    <button libButton appearance="primary" size="m" [disabled]="isButtonDisabled || isSubmitting" (click)="onSubmit()">
      <mat-spinner *ngIf="isSubmitting" [diameter]="16"></mat-spinner>
      <span *ngIf="!isSubmitting">{{ "forms.generate" | translate }}</span>
    </button>
  </footer>
</div>
